export default __webpack_public_path__ + "static/media/profile_pic.7f9bfc07.png";